import React from "react";

import { Props } from "./types";

function AttachmentsIcon({ className }: Props) {
  return (
    <svg viewBox="0 0 32.779 33.916" className={className}>
      <path
        d="M32.16,16.575,18.375,30.36A9.005,9.005,0,0,1,5.64,17.625L19.425,3.84a6,6,0,0,1,8.49,8.49l-13.8,13.785A3,3,0,1,1,9.87,21.87L22.6,9.15"
        transform="translate(-1.502 -0.582)"
        fill="none"
        stroke="#F26200"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
      />
    </svg>
  );
}

export { AttachmentsIcon };
